var render = function render(){
  var _vm$notIncluded;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": _vm.uuid
    }
  }, [_vm._v("Adresa")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.googlePlace.formattedAddress,
      expression: "googlePlace.formattedAddress"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "id": _vm.uuid
    },
    domProps: {
      "value": _vm.googlePlace.formattedAddress
    },
    on: {
      "change": function change($event) {
        return _vm.getSidloObject(true);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.googlePlace, "formattedAddress", $event.target.value);
      }
    }
  })]), _vm.loaded && !_vm.shortened ? _c('div', [!_vm.countryDropdown && _vm.addressInformationBooleans.address_text_country ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_country,
      expression: "addressInformation.address_text_country"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "krajina",
      "id": "slo-2"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_country
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_country", $event.target.value);
      }
    }
  })]) : _vm._e(), _vm.countryDropdown && _vm.addressInformationBooleans.address_text_country ? _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "value-correction": _vm.addressInformation.address_text_country,
      "id": 'permanent_address_country',
      "init-value": _vm.addressInformation.address_text_country,
      "options": _vm.formTemplate.correspondence_address_country.choices,
      "normal": "",
      "name": 'Krajina'
    },
    on: {
      "select": function select($event) {
        _vm.addressInformation.address_text_country = $event;
      }
    }
  })], 1) : _vm._e(), _vm.addressInformationBooleans.address_text_county ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_county,
      expression: "addressInformation.address_text_county"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Kraj",
      "placeholder": "",
      "id": "Kraj"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_county
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_county", $event.target.value);
      }
    }
  })]) : _vm._e(), _vm.addressInformationBooleans.address_text_district ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_district,
      expression: "addressInformation.address_text_district"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "okres",
      "placeholder": "",
      "id": "okres"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_district
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_district", $event.target.value);
      }
    }
  })]) : _vm._e(), _vm.addressInformationBooleans.address_text_city ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_city,
      expression: "addressInformation.address_text_city"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Mesto",
      "id": "Mesto"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_city
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_city", $event.target.value);
      }
    }
  })]) : _vm._e(), _vm.addressInformationBooleans.address_text_street ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_street,
      expression: "addressInformation.address_text_street"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Ulica",
      "id": "Ulica"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_street
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_street", $event.target.value);
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_zip,
      expression: "addressInformation.address_text_zip"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "zip",
      "id": "zip"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_zip
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_zip", $event.target.value);
      }
    }
  })]), (_vm.house || _vm.flat) && !_vm.notBuilt ? _c('div', [!((_vm$notIncluded = _vm.notIncluded) !== null && _vm$notIncluded !== void 0 && _vm$notIncluded.supisne) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_popisne,
      expression: "addressInformation.address_text_popisne"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "popisne",
      "placeholder": "",
      "id": "popisne"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_popisne
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_popisne", $event.target.value);
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "orient"
    }
  }, [_vm._v(_vm._s(_vm.flat ? "Vchod" : "Orientačné číslo")), _c('strong')]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.address_text_number,
      expression: "addressInformation.address_text_number"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "orient",
      "placeholder": "",
      "id": "orient"
    },
    domProps: {
      "value": _vm.addressInformation.address_text_number
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "address_text_number", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm.house || _vm.flat || _vm.land ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.cislo_lv,
      expression: "addressInformation.cislo_lv"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "listVlast",
      "placeholder": "",
      "id": "listVlast"
    },
    domProps: {
      "value": _vm.addressInformation.cislo_lv
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "cislo_lv", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.addressInformation.cislo_parcely,
      expression: "addressInformation.cislo_parcely"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "cisParcely",
      "placeholder": "",
      "id": "cisParcely"
    },
    domProps: {
      "value": _vm.addressInformation.cislo_parcely
    },
    on: {
      "change": _vm.emitAddressObject,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.addressInformation, "cislo_parcely", $event.target.value);
      }
    }
  })])]) : _vm._e()]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "slo-2"
    }
  }, [_vm._v("Krajina"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Kraj"
    }
  }, [_vm._v("Kraj"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "okres"
    }
  }, [_vm._v("Okres"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Mesto"
    }
  }, [_vm._v("Obec"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Ulica"
    }
  }, [_vm._v("Ulica"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("PSČ"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "popisne"
    }
  }, [_vm._v("Súpisné číslo"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "listVlast"
    }
  }, [_vm._v("Číslo listu vlastníctva"), _c('strong')]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "cisParcely"
    }
  }, [_vm._v("Číslo parcely"), _c('strong')]);

}]

export { render, staticRenderFns }